import React from 'react'
import styled, { css } from 'styled-components'
import { string, bool } from 'prop-types'
import { stripUnit } from 'polished'
import { Link } from 'gatsby'

import * as spacing from 'styles/spacing'
import { media } from 'styles/media'
import { fontSizes } from 'styles/typography'
import { white, black } from 'styles/colors'

const Container = styled(Link)`
  display: block;
  font-size: ${fontSizes.tiny};
  text-transform: uppercase;
  color: ${white};
  letter-spacing: 0.1em;
  text-align: left;

  ${props =>
    props.isLight &&
    css`
      color: ${black};
    `}

  ${media.medium`
    text-align: right;
  `};

  & + & {
    margin-left: ${spacing.large};

    ${media.small`
      margin-left: ${spacing.xLarge};
    `};

    ${media.medium`
      margin-left: 0;
      margin-top: ${stripUnit(spacing.medium) * 1.25 + 'px'};
    `};

    ${media.xLarge`
      margin-top: ${spacing.large};
    `};
  }
`

const getElement = props => {
  if (props.to) {
    return Link
  }

  return 'a'
}

const FooterLink = ({ label, className, isLight, ...rest }) => (
  <Container isLight={isLight} className={className} as={getElement(rest)} {...rest}>
    {label}
  </Container>
)

FooterLink.propTypes = {
  label: string.isRequired,
  className: string,
  isLight: bool
}

export default FooterLink
